import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footerRow">
        <div className="footerBrand">
          <div>
            <div className="footerName">Protek Studio Design</div>
            <div className="footerTag">
              boutique design studio • elegant interiors • luxury spaces
            </div>
          </div>
        </div>

        <div className="footerLinks">
          <Link to="/services">Services</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footerCopy">
          © {new Date().getFullYear()} Protek Studio Design. Elegant design. Refined luxury.
        </div>

        <div className="footerPoweredWrap">
          <a
            className="footerPoweredBtn"
            href="https://vrnd.tech/"
            target="_blank"
            rel="noreferrer"
          >
            Powered by VRND Business Solutions
          </a>
        </div>
      </div>
    </footer>
  );
}
